<template>
  <transition name="modal">
    <div
      v-if="showComponent"
      class="modal"
      @click="fecharModal($event)"
    >
      <div class="modal__container">
        <Dynamic
          v-if="showComponent"
          :data="componentData"
          @close="close"
        />
      </div>
    </div>
  </transition>
</template>


<script>

export default {
    name: "Modal",

    data() {
      return {
        showComponent: false,
        componentData: {}
      }
    },

    mounted() {
      this.$root.$on('modal', payload => {
        this.$options.components.Dynamic = () => import(`@/components/${payload.component}`)
        this.showComponent = true
      })
    },

    methods: {
      close() {
        this.showComponent = false
      },

      fecharModal(event) {
        if(event.target === event.currentTarget)
          this.close()
      },
    }
}
</script>


<style scoped>

.modal::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 100;
  background: rgba(0, 0, 0, .5);
}

.modal {
  position: fixed;
  display: flex;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  height: 100%;
}

.modal__container {
  position: relative;
  z-index: 100;
  background: #fff;
  z-index: 100;
  margin: auto;
  border-radius: 4px;
}

.modal-enter-active {
  animation: modal .3s ease-out;
}
.modal-leave-active {
  animation: modal .3s ease-in reverse;
}
@keyframes modal {
  0% {
    opacity: 0;
    transform: translateY(-30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>